var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useContext } from 'react';
import { LoadingBounce, UserAvatar } from '@michelin/acid-components';
import { Divider, MenuItem, ListItemIcon, ListItemText, } from '@material-ui/core';
import { Language } from '@material-ui/icons';
import MissingTranslations from '../../compositions/MissingTranslations';
import HeaderLogoutBtn from './HeaderLogoutBtn/HeaderLogoutBtn';
import { LanguageSwitch } from './LanguageSwitch/LanguageSwitch';
import { ThemeSwitch } from './ThemeSwitch/ThemeSwitch';
import { ChangePassword } from './ChangePassword/ChangePassword';
import { useStyles } from '../../styles/profileBoxStyles';
import { ProfileMenuItem } from './ProfileMenuItem';
import i18n from '../../translations/CentralTranslation';
import { AppSwitch } from '../AppSwitch/AppSwitch';
import { CentralProviderContext } from '../../centralProviderContext/CentralProviderContext';
import { UserProfile } from './UserProfile/UserProfile';
import { WhatsNew } from './WhatsNew/WhatsNew';
import { CopyBearerToken } from './CopyBearerToken/CopyBearerToken';
export function ProfileBox(_a) {
    var _b;
    var _c = _a.name, name = _c === void 0 ? '' : _c, _d = _a.email, email = _d === void 0 ? '' : _d, _e = _a.profileMenuItems, profileMenuItems = _e === void 0 ? [] : _e, _f = _a.userRole, userRole = _f === void 0 ? '' : _f, languages = _a.languages, onNavigate = _a.onNavigate, showAppMenu = _a.showAppMenu, releaseNotes = _a.releaseNotes;
    var _g = __read(React.useState(null), 2), anchorEl = _g[0], setAnchorEl = _g[1];
    var _h = __read(React.useState(false), 2), shiftKey = _h[0], setShiftKey = _h[1];
    var providerContext = useContext(CentralProviderContext);
    var classes = useStyles();
    if (providerContext.currentLanguage && i18n.language !== providerContext.currentLanguage) {
        i18n.changeLanguage(providerContext.currentLanguage);
    }
    function onMenuOpen(event) {
        setShiftKey(event.shiftKey);
        setAnchorEl(event.currentTarget);
    }
    function closeDropdown() {
        setAnchorEl(null);
    }
    return (React.createElement(UserAvatar, { name: name, email: email, description: userRole, color: "primary", className: classes.container, avatarOnly: true, anchorEl: anchorEl, onClick: onMenuOpen, closeMenu: closeDropdown },
        React.createElement("div", { className: classes.info },
            React.createElement("span", { className: classes.name }, name),
            React.createElement("span", { className: classes.email }, email)),
        React.createElement(Divider, null),
        profileMenuItems.map(function (menuItem) { return (React.createElement(ProfileMenuItem, __assign({ key: "".concat(menuItem.label) }, menuItem, { closeDropdown: closeDropdown }))); }),
        showAppMenu && (React.createElement(AppSwitch, null)),
        React.createElement(UserProfile, { closeDropdown: closeDropdown }),
        languages && languages.length > 1
            ? (React.createElement(MenuItem, null,
                React.createElement(ListItemIcon, { style: { minWidth: '33px' } },
                    React.createElement(Language, { color: "primary" })),
                React.createElement(ListItemText, null,
                    React.createElement(LanguageSwitch, { onChange: onNavigate, languages: languages }))))
            : null,
        React.createElement(ChangePassword, { closeDropdown: closeDropdown }),
        shiftKey && React.createElement(CopyBearerToken, { closeDropdown: closeDropdown }),
        React.createElement(ThemeSwitch, null),
        (releaseNotes === null || releaseNotes === void 0 ? void 0 : releaseNotes.isLoading) ? React.createElement(LoadingBounce, { size: "1vh" }) : React.createElement(WhatsNew, { releaseNotes: (_b = releaseNotes.data) === null || _b === void 0 ? void 0 : _b.data }),
        React.createElement(Divider, null),
        React.createElement(MissingTranslations, null),
        React.createElement(HeaderLogoutBtn, null)));
}
//# sourceMappingURL=ProfileBox.js.map